import React, { Component } from "react";
import View from './views';
import { connect } from 'react-redux';
import { getPopupConfig } from '../../components/Popup';
import { login as loginAction } from '../../store/actions/login';
import { version } from '../../../package.json';
import constants from '../../globalization';

class Login extends Component {
  state = {
    loginInfo: null,
    popup: undefined,
  }

  componentDidMount() {
    const {
      history,
      reduxProps: { storeInfo, deviceInfo },
    } = this.props;

    if (!storeInfo.data || !deviceInfo.deviceExternalId) {
      history.push({
        pathname: '/',
        state: { deviceTypeId: 15 }
      });
      return;
    }
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps({ reduxProps }) {
    const { reduxProps: prevReduxProps } = this.props;
    const { login } = reduxProps;
    if (login.timestamp !== prevReduxProps.login.timestamp) {
      if (login.data) {
        const { history } = this.props;
        history.push({
          pathname: '/fireboard',
          state: { managerMode: true }
        });
        this.setState({ popup: undefined });
      } else if (login.error) {
        const popup = getPopupConfig('error', () => this.setState({ popup: undefined }));
        popup.message = login.error;
        this.setState({ popup });
      } else {
        const popup = getPopupConfig('spinner');
        popup.heading = constants.loginLoadingHeading;
        this.setState({ popup });
      }
    }
  }

  onPress = id => {
    const { reduxProps: { deviceApi }, dispatchLogin, location } = this.props;
    const popup = getPopupConfig('spinner');
    this.setState({ popup });
    const { deviceId } = deviceApi?.data;
    const { managerMode } = location.state || {};
    dispatchLogin(deviceId, id || null, null, managerMode);
  }

  closePopup = () => {
    this.setState({ popup: undefined });
  }

  getProps = () => {
    const { history } = this.props;
    const { loginInfo, popup, } = this.state;
    return {
      loginInfo,
      history,
      onPress: this.onPress,
      popup,
      closePopup: this.closePopup,
    };
  }

  render() {
    const viewProps = this.getProps();
    return <View {...viewProps} />;
  }
}
const mapStateToProps = reduxProps => ({
  reduxProps,
});

const mapDispatchToProps = dispatch => ({
  dispatchLogin: (storeId, code, employeeCard, managerMode) => {
    dispatch(loginAction(storeId, version, code, employeeCard, null, managerMode));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Login);
